<div class="container-fliud">
    <div class="row">
        <div class="col-12 col-sm-3 mb-2 mb-sm-0">
            <app-search-input 
            [inputSearchPlaceholder]="'Search …'" 
            class="d-flex align-items-end"
            [inputSerachValue]="paginationModel?.searchText" 
            (inputSerachValueEmit)="paginationModel.searchText = $event;paginationModel.pageNumber = 1;getVplList()">
          </app-search-input>
        </div>
        <div class="col">
            <app-checkbox
            [lableClass]="'text-light-gray '"
            (check)="paginationModel.avlVendors =!paginationModel.avlVendors;paginationModel.pageNumber = 1;getVplList()"
            [status]="paginationModel.avlVendors"
            [lableName]="'Show AVL Vendors Only'"
            [dyanamicId]="'AVLVendorsOnly'"
            [readonly]="false"
          >
          </app-checkbox>
  
        </div>
        <div class="doc-tabs pt-2">
            <div class="doc-grid equalColorRows h-100 d-flex flex-column position-relative">
              <app-ag-grid class="center-Pagination"
                [style.height]="'20rem'"
                [columnSettings]="false"
                [getRowStyle]="getRowStyle"
                [dataModel]="AgGridDataModel"
                (gridReady)="onGridReady($event)" 
                (onPagination)="onPagination($event)" 
                (onSelectionChange)="onSelectionChange($event)"
                [handleCustomHeaderDisplay]="false"
                >
              </app-ag-grid>
            </div>
          </div>

    </div>
</div>
